export const dateFormat = {
  DD_MM_YYYY: 'DD.MM.YYYY',
  'DD-MM-YYYY': 'DD-MM-YYYY',
  DD_MM_YYYY_HH_mm_ss: 'DD.MM.YYYY HH:mm:ss',
  DD_MM_YYYY_HH_mm: 'DD.MM.YYYY HH:mm',
  YYYY_MM_DDTHH_mm_ss: 'YYYY-MM-DDTHH:mm:ss',
  YYYY_MM_DD: 'YYYY-MM-DD',
  W: 'w',
  HH_mm_ss: 'HH:mm:ss',
  HH_mm: 'HH:mm',
  MM_DD: 'MM.DD'
} as const
